import { createEntityAdapter } from '@reduxjs/toolkit';
import { TeamGroup } from 'modules/championship/domain/interfaces/team-group';
import { compareTeamGroups } from 'modules/championship/domain/utils/compare-team-groups';

const groupsAdapter = createEntityAdapter<TeamGroup>({
  selectId: (group) => group.id,
  sortComparer: compareTeamGroups,
});

export default groupsAdapter;
